var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPanCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8999 9.3502H6.7999M8.49991 12.7502H6.7999M13.5999 5.9502H6.7999M16.9999 5.7802V14.6202C16.9999 16.0483 16.9999 16.7624 16.722 17.3079C16.4775 17.7877 16.0874 18.1778 15.6076 18.4223C15.0621 18.7002 14.348 18.7002 12.9199 18.7002H7.4799C6.05177 18.7002 5.3377 18.7002 4.79223 18.4223C4.31241 18.1778 3.92231 17.7877 3.67784 17.3079C3.3999 16.7624 3.3999 16.0483 3.3999 14.6202V5.7802C3.3999 4.35206 3.3999 3.638 3.67784 3.09252C3.92231 2.61271 4.31241 2.22261 4.79223 1.97813C5.3377 1.7002 6.05177 1.7002 7.4799 1.7002H12.9199C14.348 1.7002 15.0621 1.7002 15.6076 1.97813C16.0874 2.22261 16.4775 2.61271 16.722 3.09252C16.9999 3.638 16.9999 4.35206 16.9999 5.7802Z",
    stroke: "#142C4B",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanCardIcon);
export default __webpack_public_path__ + "static/media/pan-card-icon.53e7a3e433293888be34141b01d05fb6.svg";
export { ForwardRef as ReactComponent };